import React from 'react';
import StrategicInitiativesGate from '../strategic/StrategicInitiativesGate';
import StrategicInitiativesList from '../strategic/StrategicInitiativesList';

function ManagerInitiativesTab({ unitId }) {
  // Always show full strategic initiatives — feature always enabled via backend
  return (
    <StrategicInitiativesGate currentRole="manager">
      <StrategicInitiativesList />
    </StrategicInitiativesGate>
  );
}

export default ManagerInitiativesTab;
